'use strict';

import './sidenav.css';
import template from './sidenav.html';
import controller from './sidenav.controller';

const SidenavComponent = {
    bindings: {},
    template,
    controller
};

export default SidenavComponent;


// WEBPACK FOOTER //
// ./src/app/common/layout/sidenav/sidenav.component.js